export class GetContributionKeyPoints {
  ProductId: number; 
  
}